const externalRoutes = [
  {
    //  패스세이프가드 보상신청 파일다운로드 랜딩 페이지
    path: "/ccpacof",
    name: "passSafeguardCompFile",
    meta: {
      gtm: "SKT 세이프가드 보상신청 파일다운로드 랜딩 페이지"
    },
    component: () => import(/* webpackChunkName: "passSafeguardCompFile" */ "@/views/service/PassSafeguardCompFile.vue")
  },
  {
    //  패스세이프가드 보상신청 파일다운로드 랜딩 페이지 LGU
    path: "/ccpacofL",
    name: "passSafeguardCompFileLGU",
    meta: {
      gtm: "LG 세이프가드 보상신청 파일다운로드 랜딩 페이지"
    },
    component: () => import(/* webpackChunkName: "passSafeguardCompFileLGU" */ "@/views/service/PassSafeguardCompFileLGU.vue")
  },
  {
    //  패스세이프가드 보상신청 파일다운로드 랜딩 페이지 KT
    path: "/ccpacofK",
    name: "passSafeguardCompFileKT",
    meta: {
      gtm: "KT 세이프가드 보상신청 파일다운로드 랜딩 페이지"
    },
    component: () => import(/* webpackChunkName: "passSafeguardCompFileKT" */ "@/views/service/PassSafeguardCompFileKT.vue")
  },
  {
    //  패스세이프빌링 보상신청 파일다운로드 랜딩 페이지 SKT
    path: "/ccpacofSB",
    name: "passSafeguardCompFileSBS",
    meta: {
      gtm: "SKT 세이프빌링 보상신청 파일다운로드 랜딩 페이지"
    },
    component: () => import(/* webpackChunkName: "passSafeguardCompFileSBS" */ "@/views/service/PassSafeguardCompFileSBS.vue")
  },
  {
    //  정보유출 안심케어(세이프아이디) 보상신청 파일다운로드 랜딩 페이지
    path: "/safeidCompDonwload",
    name: "SafeidCompFile",
    meta: {
      gtm: "정보유출 안심케어(세이프아이디) 보상신청 파일다운로드 랜딩 페이지"
    },
    component: () => import(/* webpackChunkName: "safeidCompfile" */ "@/views/service/SafeidCompFile.vue")
  },
  {
    //  연계정보 열람 등 요구 안내 페이지
    path: "/privacy-request",
    name: "PrivacyRequest",
    meta: {
      gtm: "연계정보 열람 등 요구 안내 페이지"
    },
    component: () => import(/* webpackChunkName: "privacyRequest" */ "@/views/service/PrivacyRequest.vue")
  },
  {
    // KT 외부웹 PASS 해지
    path: "/ew/cck",
    name: "terExtWebKT",
    meta: {
      gtm: "KT 외부웹 PASS 해지"
    },
    component: () => import(/* webpackChunkName: "terExtWebKT" */ "@/views/extWeb/JoinCancelKT.vue")
  },
  {
    // 정보유출 안심케어(세이프아이디) 해지
    path: "/safeid/:code/cancle",
    name: "terExtWebSafeid",
    meta: {
      gtm: "외부 정보유출 안심케어(세이프아이디) 해지"
    },
    component: () => import(/* webpackChunkName: "terExtWebKT" */ "@/views/extWeb/SafeidJoinCancel.vue")
  },

  // GDN을 위한 설정
  {
    path: "/gdnk",
    name: "gdnKT",
    meta: {
      gtm: "SG KT 단일 GDN Redirect 페이지 W113"
    },
    component: () => import(/* webpackChunkName: "gdnKT" */ "@/views/gdn/gdnKT.vue")
  },
  {
    path: "/gdnAll",
    name: "gdnAll",
    meta: {
      gtm: "SG 통합 GDN Redirect 페이지 W113"
    },
    component: () => import(/* webpackChunkName: "gdnAll" */ "@/views/gdn/gdnAll.vue")
  },

  // GDN Join     https://epass.finbridge.co.kr:49443/ew/gdn/join
  {
    path: "/ew/gdn/join",
    alias: "/ewGdnJoin",
    name: "gdnJoin",
    meta: {
      gtm: "세이프가드 GDN Redirect 페이지 시간대별"
    },
    component: () => import(/* webpackChunkName: "gdnJoin" */ "@/views/gdn/gdnJoin.vue")
  },
  {
    // EBMP 문서 다운로드 페이지
    path: "/ebmp/:telecomName/:docCode",
    name: "Documents",
    meta: {
      gtm: "EBMP 문서 다운로드 페이지"
    },
    component: () => import(/* webpackChunkName: "document" */ "@/views/doc/Document.vue")
  },

  {
    // PASS프라임 모바일 소개 랜딩 페이지
    path: "/prime/s/intro",
    name: "PrimeIntro",
    meta: {
      gtm: "PASS프라임 모바일 소개 랜딩 페이지"
    },
    component: () => import(/* webpackChunkName: "primeIntro" */ "@/views/landing/PrimeIntro.vue")
  }
];

export default externalRoutes;
